import { 
    GENERIC_EXPORT_RECEIVE,
    GENERIC_EXPORT_STORE_TYPE, 
    GENERIC_EXPORT_STORE_TYPE_INDEX,
    GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS, 
    GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES, 
    GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA } from "../constants";

const defaultState = {
    exportObjects: [],
    dataSources: [],
    pdfCustomerData: {},
    selectedDataSources:[],
    // exportFieldItems: [],
    exportDone: false,
    fieldTemplate: '',
    activeType: '',
    areaTypeName: '',
    activeObjectIndex: -1,
    visible: false,
    exportJobObject: [{
        exportResponseType: '',
        exportTypeName: '',
        method: '',
        fieldItems: [],
    }],
}

export const genericExport = (state = defaultState, action) => {
    switch (action.type) {
    case GENERIC_EXPORT_RECEIVE:
    case GENERIC_EXPORT_STORE_TYPE:
    case GENERIC_EXPORT_STORE_TYPE_INDEX:
    case GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS:
    case GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA:
    case GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
}